// ============================================================================
// MODULAR DESIGN PRINCIPLES (MANDATORY)
// ============================================================================
// This file strictly follows:
// 1. Single Responsibility Principle - Each component does ONE thing
// 2. Separation of Concerns - Logic separated from presentation
// 3. Modular Architecture - Independent, reusable components
//
// Refer to: docs/architecture/modular-design-standards.md
// ============================================================================

// Refer to docs/architecture/python-fastapi-architecture.md

import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        borderTop: '1px solid #e0e0e0',
        mt: 'auto',
        py: 0.5,
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'transparent',
        flexShrink: 0,
        width: '100%',
        position: 'relative',
        zIndex: 1,
        overflow: 'hidden',
      }}
    >
      <Container maxWidth="lg" sx={{ py: 0, width: '100%' }}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
          sx={{ 
            width: '100%',
            py: 0.5,
            minHeight: '24px',
            maxHeight: '32px'
          }}
        >
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', lineHeight: 1 }}>
            © 2025 Nexus-AI Platform. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
